// extracted by mini-css-extract-plugin
module.exports = {"date":"advance_date__3qwCW"};